module.exports = __webpack_public_path__ + "static/media/stackalt.66f4b748.svg";